// @flow
export default (state: Object): number => state.mapModule.selectedSoilTestFilter
